(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //   <px-simple-ui-select
  //     ng-if="scannerSelect.orientation"
  //     select-for="'WORKFLOW'"
  //     list="scannerSelect.orientation"
  //     pre-selected-item="scannerSelect.orientation[0]"
  //     placeholder="'numse'"
  //     sort-by-name="true"
  //     select-by-id="true"
  //     select-identifier="'FILE_NAME_CONTEXT'"
  //     dynamic="true"
  //     disable="true/false"
  //     callback="test(item)">
  //   </px-simple-ui-select>

  function pxSimpleUiSelect(
    $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        selectFor: '=selectFor',
        list: '=list',
        preSelectedItem: '=preSelectedItem',
        placeholder: '=placeholder',
        sortByName: '=sortByName',
        // selectById: '=selectById', // THIS IS NOT USED
        selectIdentifier: '=selectIdentifier',
        dynamic: '=dynamic',
        disable: '=disable',
        callback: '&callback'
      },
      templateUrl: 'app/directives/simple-ui-select/simple-ui-select.html',
      link: function (scope) {

        scope.item = { selected: undefined };

        scope.changeItem = function (item) {
          scope.callback({ item: item.selected });
        };

        scope.$watch(() => {
          return scope.preSelectedItem;
        }, (newValue, oldValue) => {
          if (scope.preSelectedItem) {
            scope.item.selected = scope.preSelectedItem;
          }
        });

        (function () {
          createListForSelect();
          if (scope.dynamic) {
            setListerners();
          }
        })();

        function clear() {
          scope.item.selected = undefined;
        }

        function createListForSelect() {
          scope.item.selected = scope.preSelectedItem && scope.list.find(item => item.id === scope.preSelectedItem.id);
          scope.simplifiedItemsList = scope.list;
        }

        function setListerners() {
          $rootScope.$on('RESET_UI_SELECT', function (event, data) {
            if (data === scope.selectIdentifier) {
              clear();
            }
          });

          $rootScope.$on('SET_SELECTED', function (event, data) {
            if (data.identifier === scope.selectIdentifier) {
              scope.item.selected = data.item;
            }
          });

          $rootScope.$on('CHANGE_CONTEXT', function (event, data) {
            if (data.context === scope.selectIdentifier) {
              scope.list = data.list;
              createListForSelect();
            }
          });
        }

      }
    };
  }

  pxSimpleUiSelect.$inject = ['$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxSimpleUiSelect', pxSimpleUiSelect);

})();
